// Integration-guide product access is driven by per-application permissions in
// the `info` payload from the auth portal. Each product's "view" permission lives
// inside a DIFFERENT application entry (matched by applicationName):
//
//   Geo → Geo.Console → permissions["integration-geo"] includes "view"
//   SI  → Si.Console  → permissions["integration-si"]  includes "view"
//   KYC → Act.Verify  → permissions["integration-id"]  includes "view"
//
// A product's guide section (nav item + route) is shown only when the user holds
// the corresponding view permission.
export const PRODUCTS = {
  geo: {
    key: "geo",
    applicationName: "Geo.Console",
    resource: "integration-geo",
    action: "view",
    basePath: "/introduction",
  },
  si: {
    key: "si",
    applicationName: "Si.Console",
    resource: "integration-si",
    action: "view",
    basePath: "/sports-integrity",
  },
  kyc: {
    key: "kyc",
    // SSO names the KYC application "Act.Verify" (SID-2308) and its guide
    // permission "integration-id", not "integration-kyc" (SID-2372).
    applicationName: "Act.Verify",
    resource: "integration-id",
    action: "view",
    basePath: "/kyc",
  },
};

// Product order used for nav rendering and choosing the default landing product.
export const PRODUCT_ORDER = ["geo", "si", "kyc"];

// Nav links. Product links carry a `productKey` so they can be permission-filtered;
// links without a productKey (e.g. Contact) are always shown.
export const NAV_LINKS = [
  { label: "ACT Geosafe", path: "/introduction", productKey: "geo" },
  { label: "ACT Sports Integrity", path: "/sports-integrity", productKey: "si" },
  { label: "ACT ID (KYC)", path: "/kyc", productKey: "kyc" },
  { label: "Contact Us", path: "/contact" },
];
